class VideoPlayer extends HTMLElement {
  video;
  bigButton;
  smallButton;
  button;
  time;
  bar;
  timer;
  wrapper;

  constructor() {
    super();
    this.video = this.querySelector('video');
    this.wrapper = this.closest('.video-players');
    this.bigButton = this.querySelector('.video_big-button');
    this.smallButton = this.querySelector('.video_small-button');
    this.button = this.wrapper.querySelector('.video_button[data-target="' + this.id + '"]');
    this.time = this.querySelector('.video_time');
    this.bar = this.querySelector('.video_bar');
    this.timer = new window.theme.utils.Timer(this.handleTime.bind(this));
    this.button.addEventListener('click', this.switchVideo.bind(this));
    this.bigButton.addEventListener('click', this.handleVideo.bind(this));
    this.smallButton.addEventListener('click', this.handleVideo.bind(this));
    this.addEventListener('mouseenter', this.showBar.bind(this));
    this.addEventListener('mouseleave', this.hideBar.bind(this));
    this.video.addEventListener('click', this.handleVideo.bind(this));
    this.video.addEventListener('play', this.playVideo.bind(this));
    this.video.addEventListener('pause', this.pauseVideo.bind(this));
    this.video.addEventListener('ended', this.endVideo.bind(this));
    this.video.addEventListener('loadeddata', this.initVideo.bind(this));
  }
  initVideo() {
    this.timer.start();
    this.dataset.status = 'playing';
  }
  playVideo() {
    if (this.dataset.status == 'init') {
      this.dataset.status = 'loading';
    }
    else {
      this.timer.start();
      this.dataset.status = 'playing';
    }
  }
  pauseVideo() {
    this.timer.stop();
    this.dataset.status = 'paused';
  }
  endVideo() {
    this.timer.stop();
    this.dataset.status = 'ended';
  }
  handleVideo() {
    let promise;
    if (this.video.paused)
      promise = this.video.play();
    else {
      this.video.pause();
      this.bar.classList.add('bar-visible');
    }
    if (promise !== undefined)
      promise.catch(function (error) { console.log('error: ', error); });
  }
  handleTime() {
    let round = Math.round(this.video.currentTime);
    if (round < 10)
      round = '0' + round;
    this.time.innerHTML = '00:' + round;
  }
  showBar() {
    if (this.dataset.status === 'playing')
      this.bar.classList.add('bar-visible');
  }
  hideBar() {
    if (this.dataset.status === 'playing')
      this.bar.classList.remove('bar-visible');
  }
  switchVideo() {
    var videos = this.wrapper.querySelectorAll('video-player');
    var main = this;
    videos.forEach(function (video) {
      if (video.id === main.id) {
        main.removeAttribute('hidden');
        main.video.play();
      }
      else {
        video.setAttribute('hidden', '');
        video.querySelector('video').pause();
      }
    });
    this.wrapper.querySelector('.video_button[active]').removeAttribute('active');
    this.button.setAttribute('active', '');
  }
}

customElements.define('video-player', VideoPlayer);

(function () {
  function navigationVideoPlayer(dir, wrapper) {
    const videoPlayers = wrapper.querySelectorAll('video-player')
    const active = wrapper.querySelector('video-player:not([hidden])');
    const last = videoPlayers.length - 1;
    const smallButton = active.querySelector('.video_small-button');
    if (active.dataset.status === 'playing' || active.dataset.status === 'loading')
      smallButton.click();
    active.setAttribute('hidden', '');
    let selected;
    if (dir === 'prev' && active.dataset.position !== '1')
      selected = active.previousElementSibling;
    else if (dir === 'prev' && active.dataset.position === '1')
      selected = videoPlayers[last];
    else if (dir === 'next' && active.dataset.position !== '3')
      selected = active.nextElementSibling;
    else if (dir === 'next' && active.dataset.position === '3')
      selected = videoPlayers[0];
    selected.removeAttribute('hidden');
    const button = selected.querySelector('.video_small-button');
    button.click();
    wrapper.querySelector('.videos_navigation .blue').innerHTML = '0' + selected.dataset.position;
    wrapper.querySelector('.video_button[data-target="' + active.id + '"]').removeAttribute('active');
    wrapper.querySelector('.video_button[data-target="' + selected.id + '"]').setAttribute('active', '');
  }

  const videoWrappers = document.querySelectorAll('.video-players')

  videoWrappers.forEach(videoWrapper => {
    if (!videoWrapper.querySelector('.videos_navigation')) return;
    videoWrapper.querySelector('.videos_navigation .icon-arrow-left').addEventListener('click', () => { navigationVideoPlayer('prev', videoWrapper); });
    videoWrapper.querySelector('.videos_navigation .icon-arrow-right').addEventListener('click', () => { navigationVideoPlayer('next', videoWrapper); });
  })

  const toggles = document.querySelectorAll('.video-players__toggles button')

  toggles.forEach(toggle => {
    toggle.addEventListener('click', () => {
      const oldWrapper = document.querySelector('.video-players:not([hidden])')
      oldWrapper.setAttribute('hidden', '')
      const playingVideo = oldWrapper.querySelector('[data-status="playing"] video')
      if (playingVideo) playingVideo.click()
      document.querySelector('.video-players__toggles .underline').classList.remove('underline')
      toggle.classList.add('underline')
      const newWrapper = document.querySelector(`.video-players[data-position="${toggle.dataset.position}"]`)
      newWrapper.removeAttribute('hidden')
      newWrapper.querySelector('video-player:not([hidden]) video').click()
    })
  })
})()
